import React, { useRef, useEffect } from 'react'
import { LoadingIndicator } from 'shared-global-ec-uikit/components/dist/react/esm'

export type Props = {
  isLoading: boolean
  hasMore: boolean
  loadMore: () => void
  i18n: any
}

export const InfiniteScroll = ({
  isLoading,
  hasMore,
  loadMore,
  i18n,
}: Props) => {
  const loaderRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    let observedRefValue: HTMLDivElement
    const ObserverOptions = {
      root: null,
      rootMargin: '200px',
      threshold: 1.0,
    }
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && !isLoading) {
        loadMore()
      }
    }, ObserverOptions)
    if (loaderRef.current) {
      observer.observe(loaderRef.current)
      observedRefValue = loaderRef.current
    }
    return () => {
      if (observedRefValue) {
        observer.unobserve(observedRefValue)
      }
    }
  }, [loaderRef, isLoading, hasMore, loadMore])

  if (!hasMore) return <></>

  return <div ref={loaderRef}>{<LoadingIndicator variant="normal" />}</div>
}
